import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { DatePickerButton } from '../DatePickerButton/DatePickerButton';
import { IconPlay } from '../Icon/index';
import { StyledDatePickerSelect } from './DatePickerSelect.styles';

/**
 * A `DatePickerSelect` is designed specifically for `DatePicker`.
 *
 * @related [`DatePicker`]
 * @since 8.0.0
 */

export var DatePickerSelect = function DatePickerSelect(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledDatePickerSelect, null, /*#__PURE__*/React.createElement("select", props, children), /*#__PURE__*/React.createElement(DatePickerButton, {
    tabIndex: "-1"
  }, /*#__PURE__*/React.createElement(IconPlay, null)));
};
DatePickerSelect.displayName = 'DatePickerSelect';
DatePickerSelect.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
DatePickerSelect.defaultProps = {
  children: null
};